import { Component, OnInit } from '@angular/core';
import {SignInFormComponent} from "@app/channels/auth/login/partials/sign-in/partials/sign-in-form/sign-in-form.component";
import {FormBuilder} from "@angular/forms";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {DeviceHelperService} from "@mpt-fo/common/core/services/device-helper.service";
import {ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {CustomTimelineVersion} from "@mpt-fo/common/kamona/model/kamonal-model";

@Component({
  selector: 'app-mobile-sign-in-form',
  templateUrl: './mobile-sign-in-form.component.html',
  styleUrls: ['./mobile-sign-in-form.component.scss']
})
export class MobileSignInFormComponent extends SignInFormComponent implements OnInit {
   selectedSvgColor = '#FFFFFF';
   defaultSvgColor = '#546F9E';
   usernameTabClass: any = {'bg-[#E6EEFD]': true};
   phoneNumberTabClass: any = {'bg-[#0361F0]': true};
   CustomTimelineVersion = CustomTimelineVersion;
   passcodeContainerHeight = 'calc(100vh - 113px)!important';
  constructor(
	  fb: FormBuilder,
	  auth: AuthenticationService,
	  profileService: ProfileSetupService,
	  loginHelper: LoginHelperService,
	  deviceHelper: DeviceHelperService,
	  modalService: ModalService) {
	  super(fb, auth, profileService, loginHelper, deviceHelper, modalService);
  }

  ngOnInit(): void {
	  this.buildForm();
  }

  handleSelectedTab($event: number){
	  this.usernameTabClass = $event ?  {'bg-[#0361F0]': true} : {'bg-[#E6EEFD]': true};
	  this.phoneNumberTabClass = $event ?  {'bg-[#E6EEFD]': true} : {'bg-[#0361F0]': true};
	  this.setCurrentTab($event);
  }

  handleOnSubmitPasscode($event){
	  this.setPasscode($event);
	  this.handleSignIn();
  }

}
